<div class="w-full flex flex-col" >
  @if (label || description) {
  <div class="flex justify-between items-center mb-1">
    @if (label) {
    <label [for]="id" [class]="getLabelClasses()">
      {{ label }} @if(required){<span [class]="getRequiredClasses()">*</span>}
    </label>
    }
    @if (description) {
    <span [class]="getDescriptionClasses()">{{ description }}</span>
    }
  </div>
  }

  <div class="relative">
    @if (leftIcon) {
    <div class="flex items-center absolute inset-y-0 left-0 pl-3 z-0" [ngClass]="{'pointer-events-none': leftIconDisabled}">
      <NiFormIcon [class]="getIconClasses()" [icon]="leftIcon" [ngClass]="{'opacity-50': leftIconDisabled}"
        (click)="!leftIconDisabled && onIconClick(leftIcon)" (keydown.enter)="!leftIconDisabled && onIconClick(leftIcon)"></NiFormIcon>
    </div>
    }

    <!-- Loading Skeleton -->
    @if (isLoading) {
    <div @skeletonFadeIn class="absolute inset-0 flex items-center px-3 pointer-events-none z-20 rounded-lg border border-gray-600 bg-transparent" 
      [ngClass]="{
        'border-danger-500': showError && error,
        'border-gray-600': !showError || !error
      }">
      <div class="w-full h-6 bg-gray-200 rounded skeleton-shimmer"></div>
    </div>
    }

    <!-- Actual Input Field -->
    <input #inputElement 
      [type]="getInputType()" 
      [attr.inputmode]="getInputMode()" 
      [id]="id" 
      [name]="getAutocompleteSafeName()" 
      [placeholder]="placeholder" 
      [value]="value" 
      [disabled]="disabled || isLoading"
      [attr.autocomplete]="getAutocompleteValue()" 
      [attr.data-form-type]="'other'" 
      [attr.data-lpignore]="'true'" 
      [attr.data-1p-ignore]="'true'"
      [required]="required" 
      [attr.maxlength]="maxLength" 
      [class]="getInputClasses()" 
      (input)="onInputChange($event)"
      (blur)="onBlur()" 
      [readonly]="shouldPreventAutocomplete() && !focused" 
      [style.opacity]="isLoading ? '0' : '1'"
      [style.transition]="'opacity 200ms ease-out'"
      [style.background-color]="isLoading ? 'transparent' : (disabled ? '#e5e7eb' : null)"
      class="lg:h-[3.625rem] md:h-[3.625rem] sm:h-[3.625rem] xs:h-[3.625rem] h-[3rem] lg:text-[20px] md:text-[20px] sm:text-[20px] xs:text-[20px] text-[16px] placeholder:lg:text-[20px] placeholder:md:text-[20px] placeholder:sm:text-[20px] placeholder:xs:text-[20px] placeholder:text-[16px] !font-archivo relative z-0" 
      (focus)="onFocus($event)" 
      (keydown)="onKeyDown($event)" 
      (paste)="onPaste($event)" 
      (wheel)="onWheel($event)" />

    @if (rightIcon || clearable && value) {
    <div class="flex items-center absolute inset-y-0 right-0 pr-3 z-0">
      @if (clearable && value && !isLoading) {
      <button *ngIf="!disabled" type="button" tabindex="-1" [class]="getClearButtonClasses()" (click)="clearInput()">
        ✕
      </button>
      }
      @if(rightIcon && !rightIconDisabled ) {
      <NiFormIcon [class]="rightIconClass" [icon]="rightIcon" (click)="!rightIconDisabled && onIconClick(rightIcon)" (keydown.enter)="!rightIconDisabled && onIconClick(rightIcon)">
      </NiFormIcon>
      }@else if (rightIcon && rightIconDisabled && isOtpField) {
      <span class="text-primary-500 font-bold">
        {{ countdownMinutes }}:{{ countdownSeconds | number: '2.0-0' }}
      </span>


      }
    </div>
    }
  </div>

  <div class="flex items-end justify-between min-h-[25px]">
    @if (showError && error) {
    <div [class]="getErrorClasses()">{{ error }}</div>
    }
 
    @if (helperText && !(showError && error)) {
    <div [class]="getHelperClasses()" (click)="onHelperClick()" (keydown.enter)="onHelperClick()">{{ helperText }}</div>
    }
  </div>
</div>